var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgDownload = function SvgDownload(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.19764 11.6008C8.32775 11.6008 8.44177 11.5497 8.53489 11.465L11.4529 8.81378L11.4554 8.81133C11.5413 8.72758 11.5998 8.62111 11.5998 8.49094C11.5998 8.22949 11.3858 8.05416 11.1439 8.05416C11.0377 8.05416 10.9081 8.08522 10.8174 8.1723L9.51003 9.35006L8.6534 10.1482L8.66651 9.78184V5.23756C8.66651 4.96667 8.44203 4.80078 8.19764 4.80078C7.95411 4.80078 7.7331 4.96974 7.7331 5.23756L7.73309 9.77554L7.72486 10.1707L6.8891 9.3536L5.58006 8.17035L5.57973 8.17004C5.48897 8.08765 5.36649 8.05416 5.2557 8.05416C5.01382 8.05416 4.7998 8.22949 4.7998 8.49094C4.7998 8.6213 4.85418 8.72952 4.94874 8.81556L7.86473 11.465C7.95583 11.5479 8.06949 11.6008 8.19764 11.6008Z",
    fill: "#8E8E93"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 15.2C11.9765 15.2 15.2 11.9765 15.2 8C15.2 4.02355 11.9765 0.8 8 0.8C4.02355 0.8 0.8 4.02355 0.8 8C0.8 11.9765 4.02355 15.2 8 15.2ZM8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
    fill: "#8E8E93"
  })));
};
export default SvgDownload;